var cov_h1vze1ydl = function () {
  var path = '/opt/lampp/htdocs/www/omcg/apps/delta-monitoring/client/src/assets/js/plugins/jquery.slimscroll.js',
      hash = 'a1a803fed501d3e2cc9b544cb450dfd3696ec298',
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = '__coverage__',
      coverageData = {
    path: '/opt/lampp/htdocs/www/omcg/apps/delta-monitoring/client/src/assets/js/plugins/jquery.slimscroll.js',
    statementMap: {
      '0': {
        start: {
          line: 8,
          column: 0
        },
        end: {
          line: 453,
          column: 11
        }
      },
      '1': {
        start: {
          line: 9,
          column: 2
        },
        end: {
          line: 448,
          column: 5
        }
      },
      '2': {
        start: {
          line: 11,
          column: 23
        },
        end: {
          line: 78,
          column: 7
        }
      },
      '3': {
        start: {
          line: 80,
          column: 16
        },
        end: {
          line: 80,
          column: 43
        }
      },
      '4': {
        start: {
          line: 83,
          column: 6
        },
        end: {
          line: 443,
          column: 9
        }
      },
      '5': {
        start: {
          line: 84,
          column: 26
        },
        end: {
          line: 84,
          column: 30
        }
      },
      '6': {
        start: {
          line: 85,
          column: 24
        },
        end: {
          line: 85,
          column: 28
        }
      },
      '7': {
        start: {
          line: 86,
          column: 22
        },
        end: {
          line: 86,
          column: 26
        }
      },
      '8': {
        start: {
          line: 87,
          column: 24
        },
        end: {
          line: 87,
          column: 28
        }
      },
      '9': {
        start: {
          line: 88,
          column: 23
        },
        end: {
          line: 88,
          column: 27
        }
      },
      '10': {
        start: {
          line: 89,
          column: 24
        },
        end: {
          line: 89,
          column: 28
        }
      },
      '11': {
        start: {
          line: 90,
          column: 28
        },
        end: {
          line: 90,
          column: 32
        }
      },
      '12': {
        start: {
          line: 91,
          column: 25
        },
        end: {
          line: 91,
          column: 29
        }
      },
      '13': {
        start: {
          line: 92,
          column: 21
        },
        end: {
          line: 92,
          column: 34
        }
      },
      '14': {
        start: {
          line: 93,
          column: 29
        },
        end: {
          line: 93,
          column: 31
        }
      },
      '15': {
        start: {
          line: 94,
          column: 28
        },
        end: {
          line: 94,
          column: 33
        }
      },
      '16': {
        start: {
          line: 97,
          column: 19
        },
        end: {
          line: 97,
          column: 26
        }
      },
      '17': {
        start: {
          line: 100,
          column: 8
        },
        end: {
          line: 144,
          column: 9
        }
      },
      '18': {
        start: {
          line: 102,
          column: 23
        },
        end: {
          line: 102,
          column: 37
        }
      },
      '19': {
        start: {
          line: 105,
          column: 10
        },
        end: {
          line: 105,
          column: 45
        }
      },
      '20': {
        start: {
          line: 106,
          column: 10
        },
        end: {
          line: 106,
          column: 47
        }
      },
      '21': {
        start: {
          line: 108,
          column: 10
        },
        end: {
          line: 108,
          column: 25
        }
      },
      '22': {
        start: {
          line: 111,
          column: 10
        },
        end: {
          line: 137,
          column: 11
        }
      },
      '23': {
        start: {
          line: 113,
          column: 12
        },
        end: {
          line: 119,
          column: 13
        }
      },
      '24': {
        start: {
          line: 114,
          column: 14
        },
        end: {
          line: 114,
          column: 48
        }
      },
      '25': {
        start: {
          line: 115,
          column: 14
        },
        end: {
          line: 115,
          column: 39
        }
      },
      '26': {
        start: {
          line: 116,
          column: 29
        },
        end: {
          line: 116,
          column: 58
        }
      },
      '27': {
        start: {
          line: 117,
          column: 14
        },
        end: {
          line: 117,
          column: 48
        }
      },
      '28': {
        start: {
          line: 118,
          column: 14
        },
        end: {
          line: 118,
          column: 39
        }
      },
      '29': {
        start: {
          line: 121,
          column: 12
        },
        end: {
          line: 133,
          column: 13
        }
      },
      '30': {
        start: {
          line: 123,
          column: 14
        },
        end: {
          line: 123,
          column: 48
        }
      },
      '31': {
        start: {
          line: 124,
          column: 19
        },
        end: {
          line: 133,
          column: 13
        }
      },
      '32': {
        start: {
          line: 126,
          column: 14
        },
        end: {
          line: 126,
          column: 49
        }
      },
      '33': {
        start: {
          line: 127,
          column: 19
        },
        end: {
          line: 133,
          column: 13
        }
      },
      '34': {
        start: {
          line: 129,
          column: 14
        },
        end: {
          line: 129,
          column: 27
        }
      },
      '35': {
        start: {
          line: 130,
          column: 14
        },
        end: {
          line: 130,
          column: 28
        }
      },
      '36': {
        start: {
          line: 131,
          column: 14
        },
        end: {
          line: 131,
          column: 26
        }
      },
      '37': {
        start: {
          line: 132,
          column: 14
        },
        end: {
          line: 132,
          column: 21
        }
      },
      '38': {
        start: {
          line: 136,
          column: 12
        },
        end: {
          line: 136,
          column: 47
        }
      },
      '39': {
        start: {
          line: 139,
          column: 10
        },
        end: {
          line: 139,
          column: 17
        }
      },
      '40': {
        start: {
          line: 140,
          column: 15
        },
        end: {
          line: 144,
          column: 9
        }
      },
      '41': {
        start: {
          line: 141,
          column: 10
        },
        end: {
          line: 143,
          column: 11
        }
      },
      '42': {
        start: {
          line: 142,
          column: 12
        },
        end: {
          line: 142,
          column: 19
        }
      },
      '43': {
        start: {
          line: 147,
          column: 8
        },
        end: {
          line: 147,
          column: 74
        }
      },
      '44': {
        start: {
          line: 150,
          column: 24
        },
        end: {
          line: 157,
          column: 14
        }
      },
      '45': {
        start: {
          line: 160,
          column: 8
        },
        end: {
          line: 164,
          column: 11
        }
      },
      '46': {
        start: {
          line: 167,
          column: 19
        },
        end: {
          line: 179,
          column: 14
        }
      },
      '47': {
        start: {
          line: 182,
          column: 18
        },
        end: {
          line: 196,
          column: 14
        }
      },
      '48': {
        start: {
          line: 199,
          column: 23
        },
        end: {
          line: 199,
          column: 89
        }
      },
      '49': {
        start: {
          line: 200,
          column: 8
        },
        end: {
          line: 200,
          column: 25
        }
      },
      '50': {
        start: {
          line: 201,
          column: 8
        },
        end: {
          line: 201,
          column: 24
        }
      },
      '51': {
        start: {
          line: 204,
          column: 8
        },
        end: {
          line: 204,
          column: 25
        }
      },
      '52': {
        start: {
          line: 207,
          column: 8
        },
        end: {
          line: 207,
          column: 32
        }
      },
      '53': {
        start: {
          line: 208,
          column: 8
        },
        end: {
          line: 208,
          column: 33
        }
      },
      '54': {
        start: {
          line: 211,
          column: 8
        },
        end: {
          line: 235,
          column: 9
        }
      },
      '55': {
        start: {
          line: 212,
          column: 10
        },
        end: {
          line: 234,
          column: 13
        }
      },
      '56': {
        start: {
          line: 213,
          column: 25
        },
        end: {
          line: 213,
          column: 36
        }
      },
      '57': {
        start: {
          line: 214,
          column: 12
        },
        end: {
          line: 214,
          column: 27
        }
      },
      '58': {
        start: {
          line: 215,
          column: 22
        },
        end: {
          line: 215,
          column: 48
        }
      },
      '59': {
        start: {
          line: 216,
          column: 26
        },
        end: {
          line: 216,
          column: 33
        }
      },
      '60': {
        start: {
          line: 218,
          column: 12
        },
        end: {
          line: 222,
          column: 15
        }
      },
      '61': {
        start: {
          line: 219,
          column: 30
        },
        end: {
          line: 219,
          column: 49
        }
      },
      '62': {
        start: {
          line: 220,
          column: 14
        },
        end: {
          line: 220,
          column: 38
        }
      },
      '63': {
        start: {
          line: 221,
          column: 14
        },
        end: {
          line: 221,
          column: 58
        }
      },
      '64': {
        start: {
          line: 224,
          column: 12
        },
        end: {
          line: 228,
          column: 15
        }
      },
      '65': {
        start: {
          line: 225,
          column: 14
        },
        end: {
          line: 225,
          column: 30
        }
      },
      '66': {
        start: {
          line: 226,
          column: 14
        },
        end: {
          line: 226,
          column: 24
        }
      },
      '67': {
        start: {
          line: 227,
          column: 14
        },
        end: {
          line: 227,
          column: 41
        }
      },
      '68': {
        start: {
          line: 229,
          column: 12
        },
        end: {
          line: 229,
          column: 25
        }
      },
      '69': {
        start: {
          line: 231,
          column: 12
        },
        end: {
          line: 231,
          column: 32
        }
      },
      '70': {
        start: {
          line: 232,
          column: 12
        },
        end: {
          line: 232,
          column: 31
        }
      },
      '71': {
        start: {
          line: 233,
          column: 12
        },
        end: {
          line: 233,
          column: 25
        }
      },
      '72': {
        start: {
          line: 238,
          column: 8
        },
        end: {
          line: 242,
          column: 11
        }
      },
      '73': {
        start: {
          line: 239,
          column: 10
        },
        end: {
          line: 239,
          column: 20
        }
      },
      '74': {
        start: {
          line: 241,
          column: 10
        },
        end: {
          line: 241,
          column: 20
        }
      },
      '75': {
        start: {
          line: 245,
          column: 8
        },
        end: {
          line: 249,
          column: 11
        }
      },
      '76': {
        start: {
          line: 246,
          column: 10
        },
        end: {
          line: 246,
          column: 27
        }
      },
      '77': {
        start: {
          line: 248,
          column: 10
        },
        end: {
          line: 248,
          column: 28
        }
      },
      '78': {
        start: {
          line: 252,
          column: 8
        },
        end: {
          line: 259,
          column: 11
        }
      },
      '79': {
        start: {
          line: 253,
          column: 10
        },
        end: {
          line: 253,
          column: 29
        }
      },
      '80': {
        start: {
          line: 254,
          column: 10
        },
        end: {
          line: 254,
          column: 20
        }
      },
      '81': {
        start: {
          line: 255,
          column: 10
        },
        end: {
          line: 255,
          column: 20
        }
      },
      '82': {
        start: {
          line: 257,
          column: 10
        },
        end: {
          line: 257,
          column: 30
        }
      },
      '83': {
        start: {
          line: 258,
          column: 10
        },
        end: {
          line: 258,
          column: 20
        }
      },
      '84': {
        start: {
          line: 262,
          column: 8
        },
        end: {
          line: 267,
          column: 11
        }
      },
      '85': {
        start: {
          line: 263,
          column: 10
        },
        end: {
          line: 266,
          column: 11
        }
      },
      '86': {
        start: {
          line: 265,
          column: 12
        },
        end: {
          line: 265,
          column: 56
        }
      },
      '87': {
        start: {
          line: 269,
          column: 8
        },
        end: {
          line: 281,
          column: 11
        }
      },
      '88': {
        start: {
          line: 271,
          column: 10
        },
        end: {
          line: 273,
          column: 11
        }
      },
      '89': {
        start: {
          line: 272,
          column: 12
        },
        end: {
          line: 272,
          column: 45
        }
      },
      '90': {
        start: {
          line: 274,
          column: 10
        },
        end: {
          line: 280,
          column: 11
        }
      },
      '91': {
        start: {
          line: 276,
          column: 25
        },
        end: {
          line: 276,
          column: 90
        }
      },
      '92': {
        start: {
          line: 278,
          column: 12
        },
        end: {
          line: 278,
          column: 38
        }
      },
      '93': {
        start: {
          line: 279,
          column: 12
        },
        end: {
          line: 279,
          column: 56
        }
      },
      '94': {
        start: {
          line: 284,
          column: 8
        },
        end: {
          line: 284,
          column: 23
        }
      },
      '95': {
        start: {
          line: 287,
          column: 8
        },
        end: {
          line: 299,
          column: 9
        }
      },
      '96': {
        start: {
          line: 289,
          column: 10
        },
        end: {
          line: 289,
          column: 63
        }
      },
      '97': {
        start: {
          line: 290,
          column: 10
        },
        end: {
          line: 290,
          column: 33
        }
      },
      '98': {
        start: {
          line: 291,
          column: 15
        },
        end: {
          line: 299,
          column: 9
        }
      },
      '99': {
        start: {
          line: 293,
          column: 10
        },
        end: {
          line: 293,
          column: 63
        }
      },
      '100': {
        start: {
          line: 296,
          column: 10
        },
        end: {
          line: 298,
          column: 11
        }
      },
      '101': {
        start: {
          line: 297,
          column: 12
        },
        end: {
          line: 297,
          column: 23
        }
      },
      '102': {
        start: {
          line: 302,
          column: 8
        },
        end: {
          line: 302,
          column: 26
        }
      },
      '103': {
        start: {
          line: 306,
          column: 10
        },
        end: {
          line: 308,
          column: 11
        }
      },
      '104': {
        start: {
          line: 307,
          column: 12
        },
        end: {
          line: 307,
          column: 19
        }
      },
      '105': {
        start: {
          line: 310,
          column: 10
        },
        end: {
          line: 310,
          column: 32
        }
      },
      '106': {
        start: {
          line: 312,
          column: 22
        },
        end: {
          line: 312,
          column: 23
        }
      },
      '107': {
        start: {
          line: 313,
          column: 10
        },
        end: {
          line: 315,
          column: 11
        }
      },
      '108': {
        start: {
          line: 314,
          column: 12
        },
        end: {
          line: 314,
          column: 40
        }
      },
      '109': {
        start: {
          line: 316,
          column: 10
        },
        end: {
          line: 318,
          column: 11
        }
      },
      '110': {
        start: {
          line: 317,
          column: 12
        },
        end: {
          line: 317,
          column: 33
        }
      },
      '111': {
        start: {
          line: 320,
          column: 25
        },
        end: {
          line: 320,
          column: 64
        }
      },
      '112': {
        start: {
          line: 321,
          column: 10
        },
        end: {
          line: 324,
          column: 11
        }
      },
      '113': {
        start: {
          line: 323,
          column: 12
        },
        end: {
          line: 323,
          column: 39
        }
      },
      '114': {
        start: {
          line: 327,
          column: 10
        },
        end: {
          line: 329,
          column: 11
        }
      },
      '115': {
        start: {
          line: 328,
          column: 12
        },
        end: {
          line: 328,
          column: 31
        }
      },
      '116': {
        start: {
          line: 330,
          column: 10
        },
        end: {
          line: 332,
          column: 11
        }
      },
      '117': {
        start: {
          line: 331,
          column: 12
        },
        end: {
          line: 331,
          column: 34
        }
      },
      '118': {
        start: {
          line: 336,
          column: 10
        },
        end: {
          line: 336,
          column: 32
        }
      },
      '119': {
        start: {
          line: 337,
          column: 22
        },
        end: {
          line: 337,
          column: 23
        }
      },
      '120': {
        start: {
          line: 338,
          column: 25
        },
        end: {
          line: 338,
          column: 61
        }
      },
      '121': {
        start: {
          line: 340,
          column: 10
        },
        end: {
          line: 355,
          column: 11
        }
      },
      '122': {
        start: {
          line: 342,
          column: 12
        },
        end: {
          line: 342,
          column: 109
        }
      },
      '123': {
        start: {
          line: 345,
          column: 12
        },
        end: {
          line: 345,
          column: 57
        }
      },
      '124': {
        start: {
          line: 351,
          column: 12
        },
        end: {
          line: 351,
          column: 67
        }
      },
      '125': {
        start: {
          line: 354,
          column: 12
        },
        end: {
          line: 354,
          column: 41
        }
      },
      '126': {
        start: {
          line: 358,
          column: 10
        },
        end: {
          line: 358,
          column: 96
        }
      },
      '127': {
        start: {
          line: 359,
          column: 10
        },
        end: {
          line: 359,
          column: 74
        }
      },
      '128': {
        start: {
          line: 361,
          column: 10
        },
        end: {
          line: 366,
          column: 11
        }
      },
      '129': {
        start: {
          line: 362,
          column: 12
        },
        end: {
          line: 362,
          column: 22
        }
      },
      '130': {
        start: {
          line: 363,
          column: 28
        },
        end: {
          line: 363,
          column: 73
        }
      },
      '131': {
        start: {
          line: 364,
          column: 12
        },
        end: {
          line: 364,
          column: 65
        }
      },
      '132': {
        start: {
          line: 365,
          column: 12
        },
        end: {
          line: 365,
          column: 45
        }
      },
      '133': {
        start: {
          line: 369,
          column: 10
        },
        end: {
          line: 369,
          column: 30
        }
      },
      '134': {
        start: {
          line: 372,
          column: 10
        },
        end: {
          line: 372,
          column: 47
        }
      },
      '135': {
        start: {
          line: 375,
          column: 10
        },
        end: {
          line: 375,
          column: 20
        }
      },
      '136': {
        start: {
          line: 378,
          column: 10
        },
        end: {
          line: 378,
          column: 20
        }
      },
      '137': {
        start: {
          line: 382,
          column: 10
        },
        end: {
          line: 387,
          column: 11
        }
      },
      '138': {
        start: {
          line: 383,
          column: 12
        },
        end: {
          line: 383,
          column: 71
        }
      },
      '139': {
        start: {
          line: 384,
          column: 12
        },
        end: {
          line: 384,
          column: 67
        }
      },
      '140': {
        start: {
          line: 386,
          column: 12
        },
        end: {
          line: 386,
          column: 59
        }
      },
      '141': {
        start: {
          line: 392,
          column: 10
        },
        end: {
          line: 392,
          column: 105
        }
      },
      '142': {
        start: {
          line: 393,
          column: 10
        },
        end: {
          line: 393,
          column: 46
        }
      },
      '143': {
        start: {
          line: 396,
          column: 26
        },
        end: {
          line: 396,
          column: 74
        }
      },
      '144': {
        start: {
          line: 397,
          column: 10
        },
        end: {
          line: 397,
          column: 29
        }
      },
      '145': {
        start: {
          line: 402,
          column: 10
        },
        end: {
          line: 402,
          column: 25
        }
      },
      '146': {
        start: {
          line: 403,
          column: 10
        },
        end: {
          line: 403,
          column: 34
        }
      },
      '147': {
        start: {
          line: 406,
          column: 10
        },
        end: {
          line: 417,
          column: 11
        }
      },
      '148': {
        start: {
          line: 408,
          column: 12
        },
        end: {
          line: 408,
          column: 46
        }
      },
      '149': {
        start: {
          line: 411,
          column: 12
        },
        end: {
          line: 414,
          column: 13
        }
      },
      '150': {
        start: {
          line: 412,
          column: 26
        },
        end: {
          line: 412,
          column: 67
        }
      },
      '151': {
        start: {
          line: 413,
          column: 14
        },
        end: {
          line: 413,
          column: 44
        }
      },
      '152': {
        start: {
          line: 416,
          column: 12
        },
        end: {
          line: 416,
          column: 34
        }
      },
      '153': {
        start: {
          line: 418,
          column: 10
        },
        end: {
          line: 418,
          column: 37
        }
      },
      '154': {
        start: {
          line: 421,
          column: 10
        },
        end: {
          line: 425,
          column: 11
        }
      },
      '155': {
        start: {
          line: 423,
          column: 12
        },
        end: {
          line: 423,
          column: 33
        }
      },
      '156': {
        start: {
          line: 424,
          column: 12
        },
        end: {
          line: 424,
          column: 19
        }
      },
      '157': {
        start: {
          line: 426,
          column: 10
        },
        end: {
          line: 426,
          column: 46
        }
      },
      '158': {
        start: {
          line: 427,
          column: 10
        },
        end: {
          line: 429,
          column: 11
        }
      },
      '159': {
        start: {
          line: 428,
          column: 12
        },
        end: {
          line: 428,
          column: 49
        }
      },
      '160': {
        start: {
          line: 434,
          column: 10
        },
        end: {
          line: 441,
          column: 11
        }
      },
      '161': {
        start: {
          line: 435,
          column: 12
        },
        end: {
          line: 440,
          column: 21
        }
      },
      '162': {
        start: {
          line: 436,
          column: 14
        },
        end: {
          line: 439,
          column: 15
        }
      },
      '163': {
        start: {
          line: 437,
          column: 16
        },
        end: {
          line: 437,
          column: 36
        }
      },
      '164': {
        start: {
          line: 438,
          column: 16
        },
        end: {
          line: 438,
          column: 37
        }
      },
      '165': {
        start: {
          line: 446,
          column: 6
        },
        end: {
          line: 446,
          column: 18
        }
      },
      '166': {
        start: {
          line: 450,
          column: 2
        },
        end: {
          line: 452,
          column: 5
        }
      }
    },
    fnMap: {
      '0': {
        name: '(anonymous_0)',
        decl: {
          start: {
            line: 8,
            column: 1
          },
          end: {
            line: 8,
            column: 2
          }
        },
        loc: {
          start: {
            line: 8,
            column: 14
          },
          end: {
            line: 453,
            column: 1
          }
        },
        line: 8
      },
      '1': {
        name: '(anonymous_1)',
        decl: {
          start: {
            line: 83,
            column: 16
          },
          end: {
            line: 83,
            column: 17
          }
        },
        loc: {
          start: {
            line: 83,
            column: 28
          },
          end: {
            line: 443,
            column: 7
          }
        },
        line: 83
      },
      '2': {
        name: '(anonymous_2)',
        decl: {
          start: {
            line: 212,
            column: 32
          },
          end: {
            line: 212,
            column: 33
          }
        },
        loc: {
          start: {
            line: 212,
            column: 37
          },
          end: {
            line: 230,
            column: 11
          }
        },
        line: 212
      },
      '3': {
        name: '(anonymous_3)',
        decl: {
          start: {
            line: 218,
            column: 46
          },
          end: {
            line: 218,
            column: 47
          }
        },
        loc: {
          start: {
            line: 218,
            column: 51
          },
          end: {
            line: 222,
            column: 13
          }
        },
        line: 218
      },
      '4': {
        name: '(anonymous_4)',
        decl: {
          start: {
            line: 224,
            column: 44
          },
          end: {
            line: 224,
            column: 45
          }
        },
        loc: {
          start: {
            line: 224,
            column: 49
          },
          end: {
            line: 228,
            column: 13
          }
        },
        line: 224
      },
      '5': {
        name: '(anonymous_5)',
        decl: {
          start: {
            line: 230,
            column: 44
          },
          end: {
            line: 230,
            column: 45
          }
        },
        loc: {
          start: {
            line: 230,
            column: 49
          },
          end: {
            line: 234,
            column: 11
          }
        },
        line: 230
      },
      '6': {
        name: '(anonymous_6)',
        decl: {
          start: {
            line: 238,
            column: 19
          },
          end: {
            line: 238,
            column: 20
          }
        },
        loc: {
          start: {
            line: 238,
            column: 25
          },
          end: {
            line: 240,
            column: 9
          }
        },
        line: 238
      },
      '7': {
        name: '(anonymous_7)',
        decl: {
          start: {
            line: 240,
            column: 11
          },
          end: {
            line: 240,
            column: 12
          }
        },
        loc: {
          start: {
            line: 240,
            column: 17
          },
          end: {
            line: 242,
            column: 9
          }
        },
        line: 240
      },
      '8': {
        name: '(anonymous_8)',
        decl: {
          start: {
            line: 245,
            column: 18
          },
          end: {
            line: 245,
            column: 19
          }
        },
        loc: {
          start: {
            line: 245,
            column: 24
          },
          end: {
            line: 247,
            column: 9
          }
        },
        line: 245
      },
      '9': {
        name: '(anonymous_9)',
        decl: {
          start: {
            line: 247,
            column: 11
          },
          end: {
            line: 247,
            column: 12
          }
        },
        loc: {
          start: {
            line: 247,
            column: 17
          },
          end: {
            line: 249,
            column: 9
          }
        },
        line: 247
      },
      '10': {
        name: '(anonymous_10)',
        decl: {
          start: {
            line: 252,
            column: 17
          },
          end: {
            line: 252,
            column: 18
          }
        },
        loc: {
          start: {
            line: 252,
            column: 23
          },
          end: {
            line: 256,
            column: 9
          }
        },
        line: 252
      },
      '11': {
        name: '(anonymous_11)',
        decl: {
          start: {
            line: 256,
            column: 11
          },
          end: {
            line: 256,
            column: 12
          }
        },
        loc: {
          start: {
            line: 256,
            column: 17
          },
          end: {
            line: 259,
            column: 9
          }
        },
        line: 256
      },
      '12': {
        name: '(anonymous_12)',
        decl: {
          start: {
            line: 262,
            column: 30
          },
          end: {
            line: 262,
            column: 31
          }
        },
        loc: {
          start: {
            line: 262,
            column: 40
          },
          end: {
            line: 267,
            column: 9
          }
        },
        line: 262
      },
      '13': {
        name: '(anonymous_13)',
        decl: {
          start: {
            line: 269,
            column: 29
          },
          end: {
            line: 269,
            column: 30
          }
        },
        loc: {
          start: {
            line: 269,
            column: 34
          },
          end: {
            line: 281,
            column: 9
          }
        },
        line: 269
      },
      '14': {
        name: '_onWheel',
        decl: {
          start: {
            line: 304,
            column: 17
          },
          end: {
            line: 304,
            column: 25
          }
        },
        loc: {
          start: {
            line: 304,
            column: 29
          },
          end: {
            line: 333,
            column: 9
          }
        },
        line: 304
      },
      '15': {
        name: 'scrollContent',
        decl: {
          start: {
            line: 335,
            column: 17
          },
          end: {
            line: 335,
            column: 30
          }
        },
        loc: {
          start: {
            line: 335,
            column: 51
          },
          end: {
            line: 379,
            column: 9
          }
        },
        line: 335
      },
      '16': {
        name: 'attachWheel',
        decl: {
          start: {
            line: 381,
            column: 17
          },
          end: {
            line: 381,
            column: 28
          }
        },
        loc: {
          start: {
            line: 381,
            column: 37
          },
          end: {
            line: 388,
            column: 9
          }
        },
        line: 381
      },
      '17': {
        name: 'getBarHeight',
        decl: {
          start: {
            line: 390,
            column: 17
          },
          end: {
            line: 390,
            column: 29
          }
        },
        loc: {
          start: {
            line: 390,
            column: 32
          },
          end: {
            line: 398,
            column: 9
          }
        },
        line: 390
      },
      '18': {
        name: 'showBar',
        decl: {
          start: {
            line: 400,
            column: 17
          },
          end: {
            line: 400,
            column: 24
          }
        },
        loc: {
          start: {
            line: 400,
            column: 27
          },
          end: {
            line: 430,
            column: 9
          }
        },
        line: 400
      },
      '19': {
        name: 'hideBar',
        decl: {
          start: {
            line: 432,
            column: 17
          },
          end: {
            line: 432,
            column: 24
          }
        },
        loc: {
          start: {
            line: 432,
            column: 27
          },
          end: {
            line: 442,
            column: 9
          }
        },
        line: 432
      },
      '20': {
        name: '(anonymous_20)',
        decl: {
          start: {
            line: 435,
            column: 35
          },
          end: {
            line: 435,
            column: 36
          }
        },
        loc: {
          start: {
            line: 435,
            column: 41
          },
          end: {
            line: 440,
            column: 13
          }
        },
        line: 435
      }
    },
    branchMap: {
      '0': {
        loc: {
          start: {
            line: 100,
            column: 8
          },
          end: {
            line: 144,
            column: 9
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 100,
            column: 8
          },
          end: {
            line: 144,
            column: 9
          }
        }, {
          start: {
            line: 100,
            column: 8
          },
          end: {
            line: 144,
            column: 9
          }
        }],
        line: 100
      },
      '1': {
        loc: {
          start: {
            line: 111,
            column: 10
          },
          end: {
            line: 137,
            column: 11
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 111,
            column: 10
          },
          end: {
            line: 137,
            column: 11
          }
        }, {
          start: {
            line: 111,
            column: 10
          },
          end: {
            line: 137,
            column: 11
          }
        }],
        line: 111
      },
      '2': {
        loc: {
          start: {
            line: 113,
            column: 12
          },
          end: {
            line: 119,
            column: 13
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 113,
            column: 12
          },
          end: {
            line: 119,
            column: 13
          }
        }, {
          start: {
            line: 113,
            column: 12
          },
          end: {
            line: 119,
            column: 13
          }
        }],
        line: 113
      },
      '3': {
        loc: {
          start: {
            line: 113,
            column: 16
          },
          end: {
            line: 113,
            column: 63
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 113,
            column: 16
          },
          end: {
            line: 113,
            column: 35
          }
        }, {
          start: {
            line: 113,
            column: 39
          },
          end: {
            line: 113,
            column: 63
          }
        }],
        line: 113
      },
      '4': {
        loc: {
          start: {
            line: 121,
            column: 12
          },
          end: {
            line: 133,
            column: 13
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 121,
            column: 12
          },
          end: {
            line: 133,
            column: 13
          }
        }, {
          start: {
            line: 121,
            column: 12
          },
          end: {
            line: 133,
            column: 13
          }
        }],
        line: 121
      },
      '5': {
        loc: {
          start: {
            line: 124,
            column: 19
          },
          end: {
            line: 133,
            column: 13
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 124,
            column: 19
          },
          end: {
            line: 133,
            column: 13
          }
        }, {
          start: {
            line: 124,
            column: 19
          },
          end: {
            line: 133,
            column: 13
          }
        }],
        line: 124
      },
      '6': {
        loc: {
          start: {
            line: 127,
            column: 19
          },
          end: {
            line: 133,
            column: 13
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 127,
            column: 19
          },
          end: {
            line: 133,
            column: 13
          }
        }, {
          start: {
            line: 127,
            column: 19
          },
          end: {
            line: 133,
            column: 13
          }
        }],
        line: 127
      },
      '7': {
        loc: {
          start: {
            line: 140,
            column: 15
          },
          end: {
            line: 144,
            column: 9
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 140,
            column: 15
          },
          end: {
            line: 144,
            column: 9
          }
        }, {
          start: {
            line: 140,
            column: 15
          },
          end: {
            line: 144,
            column: 9
          }
        }],
        line: 140
      },
      '8': {
        loc: {
          start: {
            line: 141,
            column: 10
          },
          end: {
            line: 143,
            column: 11
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 141,
            column: 10
          },
          end: {
            line: 143,
            column: 11
          }
        }, {
          start: {
            line: 141,
            column: 10
          },
          end: {
            line: 143,
            column: 11
          }
        }],
        line: 141
      },
      '9': {
        loc: {
          start: {
            line: 147,
            column: 19
          },
          end: {
            line: 147,
            column: 73
          }
        },
        type: 'cond-expr',
        locations: [{
          start: {
            line: 147,
            column: 42
          },
          end: {
            line: 147,
            column: 62
          }
        }, {
          start: {
            line: 147,
            column: 65
          },
          end: {
            line: 147,
            column: 73
          }
        }],
        line: 147
      },
      '10': {
        loc: {
          start: {
            line: 174,
            column: 23
          },
          end: {
            line: 174,
            column: 76
          }
        },
        type: 'cond-expr',
        locations: [{
          start: {
            line: 174,
            column: 60
          },
          end: {
            line: 174,
            column: 67
          }
        }, {
          start: {
            line: 174,
            column: 70
          },
          end: {
            line: 174,
            column: 76
          }
        }],
        line: 174
      },
      '11': {
        loc: {
          start: {
            line: 174,
            column: 24
          },
          end: {
            line: 174,
            column: 56
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 174,
            column: 24
          },
          end: {
            line: 174,
            column: 39
          }
        }, {
          start: {
            line: 174,
            column: 43
          },
          end: {
            line: 174,
            column: 56
          }
        }],
        line: 174
      },
      '12': {
        loc: {
          start: {
            line: 190,
            column: 23
          },
          end: {
            line: 190,
            column: 57
          }
        },
        type: 'cond-expr',
        locations: [{
          start: {
            line: 190,
            column: 41
          },
          end: {
            line: 190,
            column: 48
          }
        }, {
          start: {
            line: 190,
            column: 51
          },
          end: {
            line: 190,
            column: 57
          }
        }],
        line: 190
      },
      '13': {
        loc: {
          start: {
            line: 199,
            column: 23
          },
          end: {
            line: 199,
            column: 89
          }
        },
        type: 'cond-expr',
        locations: [{
          start: {
            line: 199,
            column: 49
          },
          end: {
            line: 199,
            column: 68
          }
        }, {
          start: {
            line: 199,
            column: 71
          },
          end: {
            line: 199,
            column: 89
          }
        }],
        line: 199
      },
      '14': {
        loc: {
          start: {
            line: 211,
            column: 8
          },
          end: {
            line: 235,
            column: 9
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 211,
            column: 8
          },
          end: {
            line: 235,
            column: 9
          }
        }, {
          start: {
            line: 211,
            column: 8
          },
          end: {
            line: 235,
            column: 9
          }
        }],
        line: 211
      },
      '15': {
        loc: {
          start: {
            line: 263,
            column: 10
          },
          end: {
            line: 266,
            column: 11
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 263,
            column: 10
          },
          end: {
            line: 266,
            column: 11
          }
        }, {
          start: {
            line: 263,
            column: 10
          },
          end: {
            line: 266,
            column: 11
          }
        }],
        line: 263
      },
      '16': {
        loc: {
          start: {
            line: 271,
            column: 10
          },
          end: {
            line: 273,
            column: 11
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 271,
            column: 10
          },
          end: {
            line: 273,
            column: 11
          }
        }, {
          start: {
            line: 271,
            column: 10
          },
          end: {
            line: 273,
            column: 11
          }
        }],
        line: 271
      },
      '17': {
        loc: {
          start: {
            line: 274,
            column: 10
          },
          end: {
            line: 280,
            column: 11
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 274,
            column: 10
          },
          end: {
            line: 280,
            column: 11
          }
        }, {
          start: {
            line: 274,
            column: 10
          },
          end: {
            line: 280,
            column: 11
          }
        }],
        line: 274
      },
      '18': {
        loc: {
          start: {
            line: 287,
            column: 8
          },
          end: {
            line: 299,
            column: 9
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 287,
            column: 8
          },
          end: {
            line: 299,
            column: 9
          }
        }, {
          start: {
            line: 287,
            column: 8
          },
          end: {
            line: 299,
            column: 9
          }
        }],
        line: 287
      },
      '19': {
        loc: {
          start: {
            line: 291,
            column: 15
          },
          end: {
            line: 299,
            column: 9
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 291,
            column: 15
          },
          end: {
            line: 299,
            column: 9
          }
        }, {
          start: {
            line: 291,
            column: 15
          },
          end: {
            line: 299,
            column: 9
          }
        }],
        line: 291
      },
      '20': {
        loc: {
          start: {
            line: 296,
            column: 10
          },
          end: {
            line: 298,
            column: 11
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 296,
            column: 10
          },
          end: {
            line: 298,
            column: 11
          }
        }, {
          start: {
            line: 296,
            column: 10
          },
          end: {
            line: 298,
            column: 11
          }
        }],
        line: 296
      },
      '21': {
        loc: {
          start: {
            line: 306,
            column: 10
          },
          end: {
            line: 308,
            column: 11
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 306,
            column: 10
          },
          end: {
            line: 308,
            column: 11
          }
        }, {
          start: {
            line: 306,
            column: 10
          },
          end: {
            line: 308,
            column: 11
          }
        }],
        line: 306
      },
      '22': {
        loc: {
          start: {
            line: 310,
            column: 14
          },
          end: {
            line: 310,
            column: 31
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 310,
            column: 14
          },
          end: {
            line: 310,
            column: 15
          }
        }, {
          start: {
            line: 310,
            column: 19
          },
          end: {
            line: 310,
            column: 31
          }
        }],
        line: 310
      },
      '23': {
        loc: {
          start: {
            line: 313,
            column: 10
          },
          end: {
            line: 315,
            column: 11
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 313,
            column: 10
          },
          end: {
            line: 315,
            column: 11
          }
        }, {
          start: {
            line: 313,
            column: 10
          },
          end: {
            line: 315,
            column: 11
          }
        }],
        line: 313
      },
      '24': {
        loc: {
          start: {
            line: 316,
            column: 10
          },
          end: {
            line: 318,
            column: 11
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 316,
            column: 10
          },
          end: {
            line: 318,
            column: 11
          }
        }, {
          start: {
            line: 316,
            column: 10
          },
          end: {
            line: 318,
            column: 11
          }
        }],
        line: 316
      },
      '25': {
        loc: {
          start: {
            line: 320,
            column: 25
          },
          end: {
            line: 320,
            column: 64
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 320,
            column: 25
          },
          end: {
            line: 320,
            column: 33
          }
        }, {
          start: {
            line: 320,
            column: 37
          },
          end: {
            line: 320,
            column: 48
          }
        }, {
          start: {
            line: 320,
            column: 52
          },
          end: {
            line: 320,
            column: 64
          }
        }],
        line: 320
      },
      '26': {
        loc: {
          start: {
            line: 321,
            column: 10
          },
          end: {
            line: 324,
            column: 11
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 321,
            column: 10
          },
          end: {
            line: 324,
            column: 11
          }
        }, {
          start: {
            line: 321,
            column: 10
          },
          end: {
            line: 324,
            column: 11
          }
        }],
        line: 321
      },
      '27': {
        loc: {
          start: {
            line: 327,
            column: 10
          },
          end: {
            line: 329,
            column: 11
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 327,
            column: 10
          },
          end: {
            line: 329,
            column: 11
          }
        }, {
          start: {
            line: 327,
            column: 10
          },
          end: {
            line: 329,
            column: 11
          }
        }],
        line: 327
      },
      '28': {
        loc: {
          start: {
            line: 327,
            column: 14
          },
          end: {
            line: 327,
            column: 48
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 327,
            column: 14
          },
          end: {
            line: 327,
            column: 30
          }
        }, {
          start: {
            line: 327,
            column: 34
          },
          end: {
            line: 327,
            column: 48
          }
        }],
        line: 327
      },
      '29': {
        loc: {
          start: {
            line: 330,
            column: 10
          },
          end: {
            line: 332,
            column: 11
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 330,
            column: 10
          },
          end: {
            line: 332,
            column: 11
          }
        }, {
          start: {
            line: 330,
            column: 10
          },
          end: {
            line: 332,
            column: 11
          }
        }],
        line: 330
      },
      '30': {
        loc: {
          start: {
            line: 340,
            column: 10
          },
          end: {
            line: 355,
            column: 11
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 340,
            column: 10
          },
          end: {
            line: 355,
            column: 11
          }
        }, {
          start: {
            line: 340,
            column: 10
          },
          end: {
            line: 355,
            column: 11
          }
        }],
        line: 340
      },
      '31': {
        loc: {
          start: {
            line: 351,
            column: 20
          },
          end: {
            line: 351,
            column: 66
          }
        },
        type: 'cond-expr',
        locations: [{
          start: {
            line: 351,
            column: 30
          },
          end: {
            line: 351,
            column: 46
          }
        }, {
          start: {
            line: 351,
            column: 49
          },
          end: {
            line: 351,
            column: 66
          }
        }],
        line: 351
      },
      '32': {
        loc: {
          start: {
            line: 361,
            column: 10
          },
          end: {
            line: 366,
            column: 11
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 361,
            column: 10
          },
          end: {
            line: 366,
            column: 11
          }
        }, {
          start: {
            line: 361,
            column: 10
          },
          end: {
            line: 366,
            column: 11
          }
        }],
        line: 361
      },
      '33': {
        loc: {
          start: {
            line: 382,
            column: 10
          },
          end: {
            line: 387,
            column: 11
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 382,
            column: 10
          },
          end: {
            line: 387,
            column: 11
          }
        }, {
          start: {
            line: 382,
            column: 10
          },
          end: {
            line: 387,
            column: 11
          }
        }],
        line: 382
      },
      '34': {
        loc: {
          start: {
            line: 396,
            column: 26
          },
          end: {
            line: 396,
            column: 74
          }
        },
        type: 'cond-expr',
        locations: [{
          start: {
            line: 396,
            column: 58
          },
          end: {
            line: 396,
            column: 64
          }
        }, {
          start: {
            line: 396,
            column: 67
          },
          end: {
            line: 396,
            column: 74
          }
        }],
        line: 396
      },
      '35': {
        loc: {
          start: {
            line: 406,
            column: 10
          },
          end: {
            line: 417,
            column: 11
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 406,
            column: 10
          },
          end: {
            line: 417,
            column: 11
          }
        }, {
          start: {
            line: 406,
            column: 10
          },
          end: {
            line: 417,
            column: 11
          }
        }],
        line: 406
      },
      '36': {
        loc: {
          start: {
            line: 411,
            column: 12
          },
          end: {
            line: 414,
            column: 13
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 411,
            column: 12
          },
          end: {
            line: 414,
            column: 13
          }
        }, {
          start: {
            line: 411,
            column: 12
          },
          end: {
            line: 414,
            column: 13
          }
        }],
        line: 411
      },
      '37': {
        loc: {
          start: {
            line: 412,
            column: 26
          },
          end: {
            line: 412,
            column: 67
          }
        },
        type: 'cond-expr',
        locations: [{
          start: {
            line: 412,
            column: 51
          },
          end: {
            line: 412,
            column: 56
          }
        }, {
          start: {
            line: 412,
            column: 59
          },
          end: {
            line: 412,
            column: 67
          }
        }],
        line: 412
      },
      '38': {
        loc: {
          start: {
            line: 421,
            column: 10
          },
          end: {
            line: 425,
            column: 11
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 421,
            column: 10
          },
          end: {
            line: 425,
            column: 11
          }
        }, {
          start: {
            line: 421,
            column: 10
          },
          end: {
            line: 425,
            column: 11
          }
        }],
        line: 421
      },
      '39': {
        loc: {
          start: {
            line: 427,
            column: 10
          },
          end: {
            line: 429,
            column: 11
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 427,
            column: 10
          },
          end: {
            line: 429,
            column: 11
          }
        }, {
          start: {
            line: 427,
            column: 10
          },
          end: {
            line: 429,
            column: 11
          }
        }],
        line: 427
      },
      '40': {
        loc: {
          start: {
            line: 434,
            column: 10
          },
          end: {
            line: 441,
            column: 11
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 434,
            column: 10
          },
          end: {
            line: 441,
            column: 11
          }
        }, {
          start: {
            line: 434,
            column: 10
          },
          end: {
            line: 441,
            column: 11
          }
        }],
        line: 434
      },
      '41': {
        loc: {
          start: {
            line: 436,
            column: 14
          },
          end: {
            line: 439,
            column: 15
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 436,
            column: 14
          },
          end: {
            line: 439,
            column: 15
          }
        }, {
          start: {
            line: 436,
            column: 14
          },
          end: {
            line: 439,
            column: 15
          }
        }],
        line: 436
      },
      '42': {
        loc: {
          start: {
            line: 436,
            column: 18
          },
          end: {
            line: 436,
            column: 78
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 436,
            column: 18
          },
          end: {
            line: 436,
            column: 52
          }
        }, {
          start: {
            line: 436,
            column: 56
          },
          end: {
            line: 436,
            column: 66
          }
        }, {
          start: {
            line: 436,
            column: 70
          },
          end: {
            line: 436,
            column: 78
          }
        }],
        line: 436
      },
      '43': {
        loc: {
          start: {
            line: 436,
            column: 20
          },
          end: {
            line: 436,
            column: 51
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 436,
            column: 20
          },
          end: {
            line: 436,
            column: 36
          }
        }, {
          start: {
            line: 436,
            column: 40
          },
          end: {
            line: 436,
            column: 51
          }
        }],
        line: 436
      }
    },
    s: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0,
      '4': 0,
      '5': 0,
      '6': 0,
      '7': 0,
      '8': 0,
      '9': 0,
      '10': 0,
      '11': 0,
      '12': 0,
      '13': 0,
      '14': 0,
      '15': 0,
      '16': 0,
      '17': 0,
      '18': 0,
      '19': 0,
      '20': 0,
      '21': 0,
      '22': 0,
      '23': 0,
      '24': 0,
      '25': 0,
      '26': 0,
      '27': 0,
      '28': 0,
      '29': 0,
      '30': 0,
      '31': 0,
      '32': 0,
      '33': 0,
      '34': 0,
      '35': 0,
      '36': 0,
      '37': 0,
      '38': 0,
      '39': 0,
      '40': 0,
      '41': 0,
      '42': 0,
      '43': 0,
      '44': 0,
      '45': 0,
      '46': 0,
      '47': 0,
      '48': 0,
      '49': 0,
      '50': 0,
      '51': 0,
      '52': 0,
      '53': 0,
      '54': 0,
      '55': 0,
      '56': 0,
      '57': 0,
      '58': 0,
      '59': 0,
      '60': 0,
      '61': 0,
      '62': 0,
      '63': 0,
      '64': 0,
      '65': 0,
      '66': 0,
      '67': 0,
      '68': 0,
      '69': 0,
      '70': 0,
      '71': 0,
      '72': 0,
      '73': 0,
      '74': 0,
      '75': 0,
      '76': 0,
      '77': 0,
      '78': 0,
      '79': 0,
      '80': 0,
      '81': 0,
      '82': 0,
      '83': 0,
      '84': 0,
      '85': 0,
      '86': 0,
      '87': 0,
      '88': 0,
      '89': 0,
      '90': 0,
      '91': 0,
      '92': 0,
      '93': 0,
      '94': 0,
      '95': 0,
      '96': 0,
      '97': 0,
      '98': 0,
      '99': 0,
      '100': 0,
      '101': 0,
      '102': 0,
      '103': 0,
      '104': 0,
      '105': 0,
      '106': 0,
      '107': 0,
      '108': 0,
      '109': 0,
      '110': 0,
      '111': 0,
      '112': 0,
      '113': 0,
      '114': 0,
      '115': 0,
      '116': 0,
      '117': 0,
      '118': 0,
      '119': 0,
      '120': 0,
      '121': 0,
      '122': 0,
      '123': 0,
      '124': 0,
      '125': 0,
      '126': 0,
      '127': 0,
      '128': 0,
      '129': 0,
      '130': 0,
      '131': 0,
      '132': 0,
      '133': 0,
      '134': 0,
      '135': 0,
      '136': 0,
      '137': 0,
      '138': 0,
      '139': 0,
      '140': 0,
      '141': 0,
      '142': 0,
      '143': 0,
      '144': 0,
      '145': 0,
      '146': 0,
      '147': 0,
      '148': 0,
      '149': 0,
      '150': 0,
      '151': 0,
      '152': 0,
      '153': 0,
      '154': 0,
      '155': 0,
      '156': 0,
      '157': 0,
      '158': 0,
      '159': 0,
      '160': 0,
      '161': 0,
      '162': 0,
      '163': 0,
      '164': 0,
      '165': 0,
      '166': 0
    },
    f: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0,
      '4': 0,
      '5': 0,
      '6': 0,
      '7': 0,
      '8': 0,
      '9': 0,
      '10': 0,
      '11': 0,
      '12': 0,
      '13': 0,
      '14': 0,
      '15': 0,
      '16': 0,
      '17': 0,
      '18': 0,
      '19': 0,
      '20': 0
    },
    b: {
      '0': [0, 0],
      '1': [0, 0],
      '2': [0, 0],
      '3': [0, 0],
      '4': [0, 0],
      '5': [0, 0],
      '6': [0, 0],
      '7': [0, 0],
      '8': [0, 0],
      '9': [0, 0],
      '10': [0, 0],
      '11': [0, 0],
      '12': [0, 0],
      '13': [0, 0],
      '14': [0, 0],
      '15': [0, 0],
      '16': [0, 0],
      '17': [0, 0],
      '18': [0, 0],
      '19': [0, 0],
      '20': [0, 0],
      '21': [0, 0],
      '22': [0, 0],
      '23': [0, 0],
      '24': [0, 0],
      '25': [0, 0, 0],
      '26': [0, 0],
      '27': [0, 0],
      '28': [0, 0],
      '29': [0, 0],
      '30': [0, 0],
      '31': [0, 0],
      '32': [0, 0],
      '33': [0, 0],
      '34': [0, 0],
      '35': [0, 0],
      '36': [0, 0],
      '37': [0, 0],
      '38': [0, 0],
      '39': [0, 0],
      '40': [0, 0],
      '41': [0, 0],
      '42': [0, 0, 0],
      '43': [0, 0]
    },
    _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

cov_h1vze1ydl.s[0]++;

(function ($) {
  cov_h1vze1ydl.f[0]++;
  cov_h1vze1ydl.s[1]++;

  $.fn.extend({
    slimScroll: function slimScroll(options) {
      var defaults = (cov_h1vze1ydl.s[2]++, {
        width: 'auto',

        height: '250px',

        size: '7px',

        color: '#000',

        position: 'right',

        distance: '1px',

        start: 'top',

        opacity: 0.4,

        alwaysVisible: false,

        disableFadeOut: false,

        railVisible: false,

        railColor: '#333',

        railOpacity: 0.2,

        railDraggable: true,

        railClass: 'slimScrollRail',

        barClass: 'slimScrollBar',

        wrapperClass: 'slimScrollDiv',

        allowPageScroll: false,

        wheelStep: 20,

        touchScrollStep: 200,

        borderRadius: '7px',

        railBorderRadius: '7px'
      });

      var o = (cov_h1vze1ydl.s[3]++, $.extend(defaults, options));

      cov_h1vze1ydl.s[4]++;

      this.each(function () {
        cov_h1vze1ydl.f[1]++;

        var isOverPanel = (cov_h1vze1ydl.s[5]++, null);
        var isOverBar = (cov_h1vze1ydl.s[6]++, null);
        var isDragg = (cov_h1vze1ydl.s[7]++, null);
        var queueHide = (cov_h1vze1ydl.s[8]++, null);
        var touchDif = (cov_h1vze1ydl.s[9]++, null);
        var barHeight = (cov_h1vze1ydl.s[10]++, null);
        var percentScroll = (cov_h1vze1ydl.s[11]++, null);
        var lastScroll = (cov_h1vze1ydl.s[12]++, null);
        var divS = (cov_h1vze1ydl.s[13]++, '<div></div>');
        var minBarHeight = (cov_h1vze1ydl.s[14]++, 30);
        var releaseScroll = (cov_h1vze1ydl.s[15]++, false);

        var me = (cov_h1vze1ydl.s[16]++, $(this));

        cov_h1vze1ydl.s[17]++;

        if (me.parent().hasClass(o.wrapperClass)) {
          cov_h1vze1ydl.b[0][0]++;

          var offset = (cov_h1vze1ydl.s[18]++, me.scrollTop());

          cov_h1vze1ydl.s[19]++;

          bar = me.closest('.' + o.barClass);
          cov_h1vze1ydl.s[20]++;
          rail = me.closest('.' + o.railClass);

          cov_h1vze1ydl.s[21]++;
          getBarHeight();

          cov_h1vze1ydl.s[22]++;

          if ($.isPlainObject(options)) {
            cov_h1vze1ydl.b[1][0]++;
            cov_h1vze1ydl.s[23]++;

            if ((cov_h1vze1ydl.b[3][0]++, 'height' in options) && (cov_h1vze1ydl.b[3][1]++, options.height == 'auto')) {
              cov_h1vze1ydl.b[2][0]++;
              cov_h1vze1ydl.s[24]++;

              me.parent().css('height', 'auto');
              cov_h1vze1ydl.s[25]++;
              me.css('height', 'auto');
              var height = (cov_h1vze1ydl.s[26]++, me.parent().parent().height());
              cov_h1vze1ydl.s[27]++;
              me.parent().css('height', height);
              cov_h1vze1ydl.s[28]++;
              me.css('height', height);
            } else {
              cov_h1vze1ydl.b[2][1]++;
            }

            cov_h1vze1ydl.s[29]++;
            if ('scrollTo' in options) {
              cov_h1vze1ydl.b[4][0]++;
              cov_h1vze1ydl.s[30]++;

              offset = parseInt(o.scrollTo, 10);
            } else {
                cov_h1vze1ydl.b[4][1]++;
                cov_h1vze1ydl.s[31]++;
                if ('scrollBy' in options) {
                  cov_h1vze1ydl.b[5][0]++;
                  cov_h1vze1ydl.s[32]++;

                  offset += parseInt(o.scrollBy, 10);
                } else {
                    cov_h1vze1ydl.b[5][1]++;
                    cov_h1vze1ydl.s[33]++;
                    if ('destroy' in options) {
                      cov_h1vze1ydl.b[6][0]++;
                      cov_h1vze1ydl.s[34]++;

                      bar.remove();
                      cov_h1vze1ydl.s[35]++;
                      rail.remove();
                      cov_h1vze1ydl.s[36]++;
                      me.unwrap();
                      cov_h1vze1ydl.s[37]++;
                      return;
                    } else {
                      cov_h1vze1ydl.b[6][1]++;
                    }
                  }
              }cov_h1vze1ydl.s[38]++;

            scrollContent(offset, false, true);
          } else {
            cov_h1vze1ydl.b[1][1]++;
          }

          cov_h1vze1ydl.s[39]++;
          return;
        } else {
            cov_h1vze1ydl.b[0][1]++;
            cov_h1vze1ydl.s[40]++;
            if ($.isPlainObject(options)) {
              cov_h1vze1ydl.b[7][0]++;
              cov_h1vze1ydl.s[41]++;

              if ('destroy' in options) {
                cov_h1vze1ydl.b[8][0]++;
                cov_h1vze1ydl.s[42]++;

                return;
              } else {
                cov_h1vze1ydl.b[8][1]++;
              }
            } else {
              cov_h1vze1ydl.b[7][1]++;
            }
          }cov_h1vze1ydl.s[43]++;

        o.height = o.height == 'auto' ? (cov_h1vze1ydl.b[9][0]++, me.parent().height()) : (cov_h1vze1ydl.b[9][1]++, o.height);

        var wrapper = (cov_h1vze1ydl.s[44]++, $(divS).addClass(o.wrapperClass).css({
          position: 'relative',
          overflow: 'hidden',
          width: o.width,
          height: o.height
        }));

        cov_h1vze1ydl.s[45]++;

        me.css({
          overflow: 'hidden',
          width: o.width,
          height: o.height
        });

        var rail = (cov_h1vze1ydl.s[46]++, $(divS).addClass(o.railClass).css({
          width: o.size,
          height: '100%',
          position: 'absolute',
          top: 0,
          display: (cov_h1vze1ydl.b[11][0]++, o.alwaysVisible) && (cov_h1vze1ydl.b[11][1]++, o.railVisible) ? (cov_h1vze1ydl.b[10][0]++, 'block') : (cov_h1vze1ydl.b[10][1]++, 'none'),
          'border-radius': o.railBorderRadius,
          background: o.railColor,
          opacity: o.railOpacity,
          zIndex: 90
        }));

        var bar = (cov_h1vze1ydl.s[47]++, $(divS).addClass(o.barClass).css({
          background: o.color,
          width: o.size,
          position: 'absolute',
          top: 0,
          opacity: o.opacity,
          display: o.alwaysVisible ? (cov_h1vze1ydl.b[12][0]++, 'block') : (cov_h1vze1ydl.b[12][1]++, 'none'),
          'border-radius': o.borderRadius,
          BorderRadius: o.borderRadius,
          MozBorderRadius: o.borderRadius,
          WebkitBorderRadius: o.borderRadius,
          zIndex: 99
        }));

        var posCss = (cov_h1vze1ydl.s[48]++, o.position == 'right' ? (cov_h1vze1ydl.b[13][0]++, { right: o.distance }) : (cov_h1vze1ydl.b[13][1]++, { left: o.distance }));
        cov_h1vze1ydl.s[49]++;
        rail.css(posCss);
        cov_h1vze1ydl.s[50]++;
        bar.css(posCss);

        cov_h1vze1ydl.s[51]++;

        me.wrap(wrapper);

        cov_h1vze1ydl.s[52]++;

        me.parent().append(bar);
        cov_h1vze1ydl.s[53]++;
        me.parent().append(rail);

        cov_h1vze1ydl.s[54]++;

        if (o.railDraggable) {
          cov_h1vze1ydl.b[14][0]++;
          cov_h1vze1ydl.s[55]++;

          bar.bind('mousedown', function (e) {
            cov_h1vze1ydl.f[2]++;

            var $doc = (cov_h1vze1ydl.s[56]++, $(document));
            cov_h1vze1ydl.s[57]++;
            isDragg = true;
            var t = (cov_h1vze1ydl.s[58]++, parseFloat(bar.css('top')));
            var pageY = (cov_h1vze1ydl.s[59]++, e.pageY);

            cov_h1vze1ydl.s[60]++;
            $doc.bind('mousemove.slimscroll', function (e) {
              cov_h1vze1ydl.f[3]++;

              var currTop = (cov_h1vze1ydl.s[61]++, t + e.pageY - pageY);
              cov_h1vze1ydl.s[62]++;
              bar.css('top', currTop);
              cov_h1vze1ydl.s[63]++;
              scrollContent(0, bar.position().top, false);
            });

            cov_h1vze1ydl.s[64]++;
            $doc.bind('mouseup.slimscroll', function (e) {
              cov_h1vze1ydl.f[4]++;
              cov_h1vze1ydl.s[65]++;

              isDragg = false;
              cov_h1vze1ydl.s[66]++;
              hideBar();
              cov_h1vze1ydl.s[67]++;
              $doc.unbind('.slimscroll');
            });
            cov_h1vze1ydl.s[68]++;
            return false;
          }).bind('selectstart.slimscroll', function (e) {
            cov_h1vze1ydl.f[5]++;
            cov_h1vze1ydl.s[69]++;

            e.stopPropagation();
            cov_h1vze1ydl.s[70]++;
            e.preventDefault();
            cov_h1vze1ydl.s[71]++;
            return false;
          });
        } else {
          cov_h1vze1ydl.b[14][1]++;
        }

        cov_h1vze1ydl.s[72]++;

        rail.hover(function () {
          cov_h1vze1ydl.f[6]++;
          cov_h1vze1ydl.s[73]++;

          showBar();
        }, function () {
          cov_h1vze1ydl.f[7]++;
          cov_h1vze1ydl.s[74]++;

          hideBar();
        });

        cov_h1vze1ydl.s[75]++;

        bar.hover(function () {
          cov_h1vze1ydl.f[8]++;
          cov_h1vze1ydl.s[76]++;

          isOverBar = true;
        }, function () {
          cov_h1vze1ydl.f[9]++;
          cov_h1vze1ydl.s[77]++;

          isOverBar = false;
        });

        cov_h1vze1ydl.s[78]++;

        me.hover(function () {
          cov_h1vze1ydl.f[10]++;
          cov_h1vze1ydl.s[79]++;

          isOverPanel = true;
          cov_h1vze1ydl.s[80]++;
          showBar();
          cov_h1vze1ydl.s[81]++;
          hideBar();
        }, function () {
          cov_h1vze1ydl.f[11]++;
          cov_h1vze1ydl.s[82]++;

          isOverPanel = false;
          cov_h1vze1ydl.s[83]++;
          hideBar();
        });

        cov_h1vze1ydl.s[84]++;

        me.bind('touchstart', function (e, b) {
          cov_h1vze1ydl.f[12]++;
          cov_h1vze1ydl.s[85]++;

          if (e.originalEvent.touches.length) {
            cov_h1vze1ydl.b[15][0]++;
            cov_h1vze1ydl.s[86]++;

            touchDif = e.originalEvent.touches[0].pageY;
          } else {
            cov_h1vze1ydl.b[15][1]++;
          }
        });

        cov_h1vze1ydl.s[87]++;
        me.bind('touchmove', function (e) {
          cov_h1vze1ydl.f[13]++;
          cov_h1vze1ydl.s[88]++;

          if (!releaseScroll) {
            cov_h1vze1ydl.b[16][0]++;
            cov_h1vze1ydl.s[89]++;

            e.originalEvent.preventDefault();
          } else {
            cov_h1vze1ydl.b[16][1]++;
          }
          cov_h1vze1ydl.s[90]++;
          if (e.originalEvent.touches.length) {
            cov_h1vze1ydl.b[17][0]++;

            var diff = (cov_h1vze1ydl.s[91]++, (touchDif - e.originalEvent.touches[0].pageY) / o.touchScrollStep);
            cov_h1vze1ydl.s[92]++;

            scrollContent(diff, true);
            cov_h1vze1ydl.s[93]++;
            touchDif = e.originalEvent.touches[0].pageY;
          } else {
            cov_h1vze1ydl.b[17][1]++;
          }
        });

        cov_h1vze1ydl.s[94]++;

        getBarHeight();

        cov_h1vze1ydl.s[95]++;

        if (o.start === 'bottom') {
          cov_h1vze1ydl.b[18][0]++;
          cov_h1vze1ydl.s[96]++;

          bar.css({ top: me.outerHeight() - bar.outerHeight() });
          cov_h1vze1ydl.s[97]++;
          scrollContent(0, true);
        } else {
            cov_h1vze1ydl.b[18][1]++;
            cov_h1vze1ydl.s[98]++;
            if (o.start !== 'top') {
              cov_h1vze1ydl.b[19][0]++;
              cov_h1vze1ydl.s[99]++;

              scrollContent($(o.start).position().top, null, true);

              cov_h1vze1ydl.s[100]++;

              if (!o.alwaysVisible) {
                cov_h1vze1ydl.b[20][0]++;
                cov_h1vze1ydl.s[101]++;

                bar.hide();
              } else {
                cov_h1vze1ydl.b[20][1]++;
              }
            } else {
              cov_h1vze1ydl.b[19][1]++;
            }
          }cov_h1vze1ydl.s[102]++;

        attachWheel(this);

        function _onWheel(e) {
          cov_h1vze1ydl.f[14]++;
          cov_h1vze1ydl.s[103]++;

          if (!isOverPanel) {
            cov_h1vze1ydl.b[21][0]++;
            cov_h1vze1ydl.s[104]++;

            return;
          } else {
            cov_h1vze1ydl.b[21][1]++;
          }

          cov_h1vze1ydl.s[105]++;
          e = (cov_h1vze1ydl.b[22][0]++, e) || (cov_h1vze1ydl.b[22][1]++, window.event);

          var delta = (cov_h1vze1ydl.s[106]++, 0);
          cov_h1vze1ydl.s[107]++;
          if (e.wheelDelta) {
            cov_h1vze1ydl.b[23][0]++;
            cov_h1vze1ydl.s[108]++;

            delta = -e.wheelDelta / 120;
          } else {
            cov_h1vze1ydl.b[23][1]++;
          }
          cov_h1vze1ydl.s[109]++;
          if (e.detail) {
            cov_h1vze1ydl.b[24][0]++;
            cov_h1vze1ydl.s[110]++;

            delta = e.detail / 3;
          } else {
            cov_h1vze1ydl.b[24][1]++;
          }

          var target = (cov_h1vze1ydl.s[111]++, (cov_h1vze1ydl.b[25][0]++, e.target) || (cov_h1vze1ydl.b[25][1]++, e.srcTarget) || (cov_h1vze1ydl.b[25][2]++, e.srcElement));
          cov_h1vze1ydl.s[112]++;
          if ($(target).closest('.' + o.wrapperClass).is(me.parent())) {
            cov_h1vze1ydl.b[26][0]++;
            cov_h1vze1ydl.s[113]++;

            scrollContent(delta, true);
          } else {
            cov_h1vze1ydl.b[26][1]++;
          }

          cov_h1vze1ydl.s[114]++;

          if ((cov_h1vze1ydl.b[28][0]++, e.preventDefault) && (cov_h1vze1ydl.b[28][1]++, !releaseScroll)) {
            cov_h1vze1ydl.b[27][0]++;
            cov_h1vze1ydl.s[115]++;

            e.preventDefault();
          } else {
            cov_h1vze1ydl.b[27][1]++;
          }
          cov_h1vze1ydl.s[116]++;
          if (!releaseScroll) {
            cov_h1vze1ydl.b[29][0]++;
            cov_h1vze1ydl.s[117]++;

            e.returnValue = false;
          } else {
            cov_h1vze1ydl.b[29][1]++;
          }
        }

        function scrollContent(y, isWheel, isJump) {
          cov_h1vze1ydl.f[15]++;
          cov_h1vze1ydl.s[118]++;

          releaseScroll = false;
          var delta = (cov_h1vze1ydl.s[119]++, y);
          var maxTop = (cov_h1vze1ydl.s[120]++, me.outerHeight() - bar.outerHeight());

          cov_h1vze1ydl.s[121]++;
          if (isWheel) {
            cov_h1vze1ydl.b[30][0]++;
            cov_h1vze1ydl.s[122]++;

            delta = parseInt(bar.css('top'), 10) + y * parseInt(o.wheelStep, 10) / 100 * bar.outerHeight();

            cov_h1vze1ydl.s[123]++;

            delta = Math.min(Math.max(delta, 0), maxTop);

            cov_h1vze1ydl.s[124]++;

            delta = y > 0 ? (cov_h1vze1ydl.b[31][0]++, Math.ceil(delta)) : (cov_h1vze1ydl.b[31][1]++, Math.floor(delta));

            cov_h1vze1ydl.s[125]++;

            bar.css({ top: delta + 'px' });
          } else {
            cov_h1vze1ydl.b[30][1]++;
          }

          cov_h1vze1ydl.s[126]++;

          percentScroll = parseInt(bar.css('top'), 10) / (me.outerHeight() - bar.outerHeight());
          cov_h1vze1ydl.s[127]++;
          delta = percentScroll * (me[0].scrollHeight - me.outerHeight());

          cov_h1vze1ydl.s[128]++;
          if (isJump) {
            cov_h1vze1ydl.b[32][0]++;
            cov_h1vze1ydl.s[129]++;

            delta = y;
            var offsetTop = (cov_h1vze1ydl.s[130]++, delta / me[0].scrollHeight * me.outerHeight());
            cov_h1vze1ydl.s[131]++;
            offsetTop = Math.min(Math.max(offsetTop, 0), maxTop);
            cov_h1vze1ydl.s[132]++;
            bar.css({ top: offsetTop + 'px' });
          } else {
            cov_h1vze1ydl.b[32][1]++;
          }

          cov_h1vze1ydl.s[133]++;

          me.scrollTop(delta);

          cov_h1vze1ydl.s[134]++;

          me.trigger('slimscrolling', ~~delta);

          cov_h1vze1ydl.s[135]++;

          showBar();

          cov_h1vze1ydl.s[136]++;

          hideBar();
        }

        function attachWheel(target) {
          cov_h1vze1ydl.f[16]++;
          cov_h1vze1ydl.s[137]++;

          if (window.addEventListener) {
            cov_h1vze1ydl.b[33][0]++;
            cov_h1vze1ydl.s[138]++;

            target.addEventListener('DOMMouseScroll', _onWheel, false);
            cov_h1vze1ydl.s[139]++;
            target.addEventListener('mousewheel', _onWheel, false);
          } else {
            cov_h1vze1ydl.b[33][1]++;
            cov_h1vze1ydl.s[140]++;

            document.attachEvent('onmousewheel', _onWheel);
          }
        }

        function getBarHeight() {
          cov_h1vze1ydl.f[17]++;
          cov_h1vze1ydl.s[141]++;

          barHeight = Math.max(me.outerHeight() / me[0].scrollHeight * me.outerHeight(), minBarHeight);
          cov_h1vze1ydl.s[142]++;
          bar.css({ height: barHeight + 'px' });

          var display = (cov_h1vze1ydl.s[143]++, barHeight == me.outerHeight() ? (cov_h1vze1ydl.b[34][0]++, 'none') : (cov_h1vze1ydl.b[34][1]++, 'block'));
          cov_h1vze1ydl.s[144]++;
          bar.css({ display: display });
        }

        function showBar() {
          cov_h1vze1ydl.f[18]++;
          cov_h1vze1ydl.s[145]++;

          getBarHeight();
          cov_h1vze1ydl.s[146]++;
          clearTimeout(queueHide);

          cov_h1vze1ydl.s[147]++;

          if (percentScroll == ~~percentScroll) {
            cov_h1vze1ydl.b[35][0]++;
            cov_h1vze1ydl.s[148]++;

            releaseScroll = o.allowPageScroll;

            cov_h1vze1ydl.s[149]++;

            if (lastScroll != percentScroll) {
              cov_h1vze1ydl.b[36][0]++;

              var msg = (cov_h1vze1ydl.s[150]++, ~~percentScroll == 0 ? (cov_h1vze1ydl.b[37][0]++, 'top') : (cov_h1vze1ydl.b[37][1]++, 'bottom'));
              cov_h1vze1ydl.s[151]++;
              me.trigger('slimscroll', msg);
            } else {
              cov_h1vze1ydl.b[36][1]++;
            }
          } else {
            cov_h1vze1ydl.b[35][1]++;
            cov_h1vze1ydl.s[152]++;

            releaseScroll = false;
          }
          cov_h1vze1ydl.s[153]++;
          lastScroll = percentScroll;

          cov_h1vze1ydl.s[154]++;

          if (barHeight >= me.outerHeight()) {
            cov_h1vze1ydl.b[38][0]++;
            cov_h1vze1ydl.s[155]++;

            releaseScroll = true;
            cov_h1vze1ydl.s[156]++;
            return;
          } else {
            cov_h1vze1ydl.b[38][1]++;
          }
          cov_h1vze1ydl.s[157]++;
          bar.stop(true, true).fadeIn('fast');
          cov_h1vze1ydl.s[158]++;
          if (o.railVisible) {
            cov_h1vze1ydl.b[39][0]++;
            cov_h1vze1ydl.s[159]++;

            rail.stop(true, true).fadeIn('fast');
          } else {
            cov_h1vze1ydl.b[39][1]++;
          }
        }

        function hideBar() {
          cov_h1vze1ydl.f[19]++;
          cov_h1vze1ydl.s[160]++;

          if (!o.alwaysVisible) {
            cov_h1vze1ydl.b[40][0]++;
            cov_h1vze1ydl.s[161]++;

            queueHide = setTimeout(function () {
              cov_h1vze1ydl.f[20]++;
              cov_h1vze1ydl.s[162]++;

              if ((cov_h1vze1ydl.b[42][0]++, !((cov_h1vze1ydl.b[43][0]++, o.disableFadeOut) && (cov_h1vze1ydl.b[43][1]++, isOverPanel))) && (cov_h1vze1ydl.b[42][1]++, !isOverBar) && (cov_h1vze1ydl.b[42][2]++, !isDragg)) {
                cov_h1vze1ydl.b[41][0]++;
                cov_h1vze1ydl.s[163]++;

                bar.fadeOut('slow');
                cov_h1vze1ydl.s[164]++;
                rail.fadeOut('slow');
              } else {
                cov_h1vze1ydl.b[41][1]++;
              }
            }, 1000);
          } else {
            cov_h1vze1ydl.b[40][1]++;
          }
        }
      });

      cov_h1vze1ydl.s[165]++;

      return this;
    }
  });

  cov_h1vze1ydl.s[166]++;
  $.fn.extend({
    slimscroll: $.fn.slimScroll
  });
})(jQuery);